// src/components/SacredCircuitryDeck.js

import React, { useState, useEffect } from 'react';
import { SparklesIcon } from '@heroicons/react/24/solid';
import './SacredCircuitryDeck.css'; // Asegúrate de crear este archivo CSS para estilos específicos si es necesario
import CommentSection from '../comments/CommentSection';

// El componente ahora acepta 'maxDrawsPerDay' como una prop.
const SacredCircuitryDeck = ({ sacredCircuits, symbolImages, maxDrawsPerDay = 3 }) => {
  const [drawnCards, setDrawnCards] = useState([]);
  const [isRevealing, setIsRevealing] = useState(false);
  // El estado inicial de drawsLeft se establece con la nueva prop.
  const [drawsLeft, setDrawsLeft] = useState(maxDrawsPerDay);

  useEffect(() => {
    const savedCardsJSON = localStorage.getItem('track_user_daily_circuits');
    const savedDate = localStorage.getItem('track_user_daily_circuits_date');
    const today = new Date().toISOString().split('T')[0]; // Formato YYYY-MM-DD

    if (savedCardsJSON && savedDate === today) {
      const parsedCards = JSON.parse(savedCardsJSON);
      setDrawnCards(parsedCards);
      // La lógica de reseteo ahora también usa la prop.
      setDrawsLeft(maxDrawsPerDay - parsedCards.length);
    } else {
      // Si es un nuevo día, resetea usando la prop.
      localStorage.removeItem('track_user_daily_circuits');
      localStorage.removeItem('track_user_daily_circuits_date');
      setDrawnCards([]);
      setDrawsLeft(maxDrawsPerDay);
    }
    // Se añade maxDrawsPerDay como dependencia del useEffect.
  }, [maxDrawsPerDay]);

  const handleDrawCard = () => {
    if (drawsLeft <= 0 || isRevealing) return;

    setIsRevealing(true);
    setTimeout(() => {
      const availableCircuits = sacredCircuits.filter(
        card => !drawnCards.some(drawn => drawn.id === card.id)
      );

      let newCard;
      if (availableCircuits.length > 0) {
        const randomIndex = Math.floor(Math.random() * availableCircuits.length);
        newCard = availableCircuits[randomIndex];
      } else {
        const randomIndex = Math.floor(Math.random() * sacredCircuits.length);
        newCard = sacredCircuits[randomIndex];
      }
      
      const updatedCards = [...drawnCards, newCard];
      const today = new Date().toISOString().split('T')[0];

      localStorage.setItem('track_user_daily_circuits', JSON.stringify(updatedCards));
      localStorage.setItem('track_user_daily_circuits_date', today);

      setDrawnCards(updatedCards);
      setDrawsLeft(prev => prev - 1);
      setIsRevealing(false);
    }, 1000);
  };

  return (
    <div className="text-center w-full max-w-4xl mx-auto mb-16" id="oracle">
      <h2 className="text-3xl font-bold mb-4">
        {drawsLeft > 0 ? `Receive Your Daily Guidance (${drawsLeft} draws left)` : 'Your Guidance for Today'}
      </h2>
      <p className="text-lg text-gray-400 max-w-2xl mx-auto mb-8">
        {drawsLeft > 0
          ? 'Click to draw a symbol from the Sacred Circuitry to focus on today.'
          : 'You have drawn all your symbols for today. Come back tomorrow for new guidance.'
        }
      </p>
      <div className="flex flex-wrap justify-center items-start gap-6">
        {drawnCards.map((card, index) => (
          <div key={index} className="w-48 h-64 bg-gray-900 border-2 border-purple-500 rounded-xl flex flex-col items-center justify-center p-4 fade-in-animation">
            <img 
              src={symbolImages[card.id - 1]}
              alt={card.name}
              className="w-32 h-32 object-contain"
            />
            <h4 className="text-xl font-bold mt-2 text-sky-400">{card.name}</h4>
            <p className="text-gray-300 text-sm mt-2 max-h-20 overflow-y-auto">{card.description}</p>
          </div>
        ))}

        {drawsLeft > 0 && (
          <button 
            onClick={handleDrawCard}
            disabled={isRevealing || drawsLeft <= 0}
            className="w-48 h-64 bg-gray-800 border-2 border-purple-500 rounded-xl flex items-center justify-center perspective-1000 transition-opacity duration-300 disabled:opacity-70 disabled:cursor-not-allowed"
          >
            <div className={`relative w-full h-full transition-transform duration-1000 transform-style-3d ${isRevealing ? 'rotate-y-180' : ''}`}>
              <div className="absolute w-full h-full backface-hidden flex flex-col items-center justify-center">
                <SparklesIcon className="w-16 h-16 text-purple-400"/>
                <span className="mt-2 font-semibold">Draw Card</span>
              </div>
              <div className="absolute w-full h-full backface-hidden rotate-y-180 bg-gray-900 rounded-xl flex flex-col items-center justify-center p-4">
                <SparklesIcon className="w-16 h-16 text-purple-400"/>
                <span className="mt-2 font-semibold">Revealing...</span>
              </div>
            </div>
          </button>
        )}
      </div>
    </div>
    
  );
};

export default SacredCircuitryDeck;